import React from 'react';

export const Question = ({ question, answer, onChange }) => {
    const answerValue = answer?.value || '';
    const responseValue = answer?.response || '';

    return (
        <div className="question-container" style={{ marginBottom: '1rem', padding: '0.5rem', borderBottom: '1px solid #eee' }}>
            <div style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>
                {question.id} {question.text}
            </div>

            {question.type === 'Radio' && question.options && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        {question.options.map((option) => {
                            const isSelected = answerValue === option;
                            let activeColor = '#2196F3'; // Default Blue
                            if (option === 'Yes') activeColor = '#4caf50'; // Green
                            else if (option === 'No') activeColor = '#f44336'; // Red
                            else if (option === 'N/A') activeColor = '#9e9e9e'; // Grey

                            return (
                                <button
                                    key={option}
                                                                         onClick={() => {
                                                                            if (isSelected) {
                                                                                // If the user clicks the selected option again, untick it
                                                                                onChange({ value: '', response: undefined });
                                                                            } else {
                                                                                // Otherwise, set the new option
                                                                                let response: string | undefined = undefined;
                                                                                if (option === 'No') {
                                                                                    response = question.action;
                                                                                }
                                                                                onChange({ value: option, response: response });
                                                                            }
                                                                        }}                                    style={{
                                        padding: '10px 20px',
                                        border: `2px solid ${isSelected ? activeColor : '#e0e0e0'}`,
                                        backgroundColor: isSelected ? activeColor : 'white',
                                        color: isSelected ? 'white' : '#333',
                                        borderRadius: '5px',
                                        cursor: 'pointer',
                                        fontWeight: isSelected ? 'bold' : 'normal',
                                        transition: 'all 0.2s ease',
                                        minWidth: '80px',
                                        fontSize: '14px',
                                        outline: 'none'
                                    }}
                                >
                                    {option}
                                </button>
                            );
                        })}
                    </div>
                    {answerValue === 'No' && (
                        <div style={{ marginTop: '10px' }}>
                            <h4 style={{ marginTop: 0, marginBottom: '5px', fontSize: '1rem' }}>Action</h4>
                            <textarea
                                value={responseValue || question.action}
                                onChange={(e) => onChange({ value: 'No', response: e.target.value })}
                                rows={3}
                                style={{ width: '100%', maxWidth: '500px', padding: '0.5rem', borderRadius: '4px', border: '1px solid #ccc' }}
                                placeholder="Please describe the action to be taken..."
                            />
                        </div>
                    )}
                </div>
            )}

            {question.type === 'Text' && (
                <textarea
                    value={answerValue}
                    onChange={(e) => onChange({ value: e.target.value })}
                    rows={3}
                    style={{ width: '100%', maxWidth: '500px', padding: '0.5rem' }}
                />
            )}
        </div>
    );
};
